import { graphql, withPrefix, Script } from "gatsby"

import { useLocation } from "@reach/router"
import queryString from "query-string"

import { Head as BaseHead } from "@components/Head/Head"

import { FastlyImage } from "@components/FastlyImage"
import { Box } from "@fastly/consistently"
import ContactSalesForm from "@components/Form/ContactSalesForm"

const productInterest = {
  "network-services-basic": "Network Services Basic",
  "network-services-starter": "Network Services Starter",
  "network-services-advantage": "Network Services Advantage",
  "network-services-ultimate": "Network Services Ultimate",
  "security-starter": "Security Stater",
  "security-advantage": "Security Advantage",
  "security-ultimate": "Security Ultimate",
  "compute-starter": "Compute Starter",
  "compute-advantage": "Compute Advantage",
  "compute-ultimate": "Compute Ultimate",
  "observability-starter": "Observability Starter",
  "observability-advantage": "Observability Advantage",
  "observability-ultimate": "Observability Ultimate",
  custom: "custom",
}

const RequestPricing = ({
  data: { fastlyLogo, formData, basicLeadInText, starterLeadInText, customLeadInText },
  pageContext: { leadInTextType },
}) => {
  // Convert array of labels to an object
  // i.e. { field.firstname: "First name", field.lastname: "Last name"  }
  const labels = formData.labels.items.reduce((acc, val) => ({ ...acc, [val.title]: val.text }), {})

  const gatsbyLocation = useLocation()
  const search = queryString.parse(gatsbyLocation.search)
  const pricingFormDetails = productInterest[search.package ?? search.tier]

  let leadInText = formData.leadInText
  if (leadInTextType === "basic" && basicLeadInText?.content) {
    leadInText = basicLeadInText.content
  }
  if (leadInTextType === "starter" && starterLeadInText?.content) {
    leadInText = starterLeadInText.content
  }
  if (leadInTextType === "custom" && customLeadInText?.content) {
    leadInText = customLeadInText?.content
  }

  return (
    <>
      <Box as="section" maxWidth={460} mx={{ _: "md", md: "auto" }}>
        <Box as="a" display="block" my="lg" href={withPrefix("/")}>
          <FastlyImage
            src={fastlyLogo.file.url}
            alt="Fastly Logo"
            params="?width=94&height=48&fit=crop"
            width={94}
            height={48}
          />
        </Box>
        <ContactSalesForm
          gridRowGap="16px"
          labels={labels}
          leadInText={leadInText}
          postFormText={formData.postFormText}
          confirmationText={formData.confirmationText}
          pricingFormDetails={pricingFormDetails}
          formId="1994"
        />
      </Box>
      <Script async src="/fst-post-back" />
    </>
  )
}

export default RequestPricing

export const query = graphql`
  query ($contentful_id: String!) {
    page: contentfulPage(contentful_id: { eq: $contentful_id }) {
      ...Page
    }
    fastlyLogo: contentfulAsset(contentful_id: { eq: "62ujchg2nr9NKSGrKzs0P" }) {
      file {
        url
        fileName
        contentType
      }
      svg {
        content
      }
    }
    basicLeadInText: contentfulText(contentful_id: { eq: "ZelDDyGNo8r5x8cAdNKko" }) {
      content {
        childMarkdownRemark {
          html
        }
      }
    }
    starterLeadInText: contentfulText(contentful_id: { eq: "6kGiLl2vvsHJsFcGarORWQ" }) {
      content {
        childMarkdownRemark {
          html
        }
      }
    }
    customLeadInText: contentfulText(contentful_id: { eq: "I18PtIcOaxWGlfcAeM4kE" }) {
      content {
        childMarkdownRemark {
          html
        }
      }
    }
    metaTitleMicrocopy: contentfulMicrocopy(contentful_id: { eq: "4z6n5s9zl6ZAfnwr9vcKkD" }) {
      text
    }
    formData: contentfulForm(contentful_id: { eq: "6ZGF1n0iDzBIfbt0J5pbp2" }) {
      id
      formId
      leadInText {
        childMarkdownRemark {
          html
        }
      }
      postFormText {
        childMarkdownRemark {
          html
        }
      }
      confirmationText {
        childMarkdownRemark {
          html
        }
      }
      labels {
        name
        items {
          title
          text
        }
      }
    }
  }
`

export const Head = (props) => {
  const { data, pageContext } = props

  // for /activate-basic and /activate-starter the title should be "Activate Fastly: [basic/starter]"
  const leadIn =
    pageContext.leadInTextType &&
    pageContext.leadInTextType?.charAt(0).toUpperCase() + pageContext.leadInTextType.slice(1)
  const metaTitleAppend = pageContext.leadInTextType
    ? `${data.metaTitleMicrocopy.text} ${leadIn}`
    : data.page.socialTitle

  data.page.socialTitle = metaTitleAppend

  return (
    <BaseHead {...props}>
      <script>{`
      LUX = window.LUX || {}
      LUX.label = "Contact"
    `}</script>
    </BaseHead>
  )
}
